export interface HeroSlide {
  id: number;
  title: string;
  tagline: string;
  meta: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    title: "星际迷航者",
    tagline: "在无垠星海中，寻找人类最后的家园",
    meta: "科幻 · 冒险 / 美国 / 2024",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20film%20still%2C%20lone%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20deep%20blue%20nebula%20and%20warm%20orange%20starlight%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20high%20detail%2C%20atmospheric%20space%20scene%2C%20no%20text&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: 5,
    title: "深海迷航",
    tagline: "万米之下，藏着不该存在的秘密",
    meta: "科幻 · 冒险 / 美国 / 2023",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20deep%20sea%20film%20still%2C%20submarine%20descending%20into%20a%20glowing%20ocean%20abyss%2C%20deep%20blue%20water%20and%20warm%20orange%20bioluminescence%2C%20mysterious%20atmospheric%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: 10,
    title: "极速狂飙",
    tagline: "速度的尽头，是与自己的较量",
    meta: "动作 · 赛车 / 美国 / 2024",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20action%20racing%20film%20still%2C%20sports%20car%20speeding%20through%20a%20night%20city%2C%20deep%20blue%20motion%20blur%20and%20warm%20orange%20headlights%2C%20dynamic%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: 11,
    title: "幻境之城",
    tagline: "想象力，是唯一的通行证",
    meta: "奇幻 · 冒险 / 美国 / 2023",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20fantasy%20film%20still%2C%20a%20floating%20magical%20city%20above%20the%20clouds%2C%20deep%20blue%20sky%20and%20warm%20orange%20magic%20glow%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
  {
    id: 20,
    title: "时间的旅人",
    tagline: "每一次穿越，都让她离我更远",
    meta: "科幻 · 爱情 / 英国 / 2024",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20time%20travel%20film%20still%2C%20a%20lone%20traveler%20before%20giant%20glowing%20clocks%2C%20deep%20blue%20time%20vortex%20and%20warm%20orange%20light%2C%20poetic%20atmospheric%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-05&orientation=landscape",
  },
];

export const siteIntro = {
  title: "关于看片网站",
  paragraphs: [
    "看片网站专注于影视内容的整理与推荐，汇集电影、电视剧等多种类别的作品，覆盖动作、爱情、科幻、悬疑、喜剧等丰富类型。",
    "我们提供多维度的筛选与检索工具，帮助你按类型、地区、年份快速定位想看的作品，并通过详情页了解完整的剧情简介与主创信息。",
  ],
  stats: [
    { value: "2,600+", label: "收录影视作品" },
    { value: "23", label: "细分类型标签" },
    { value: "6", label: "覆盖国家地区" },
    { value: "100%", label: "免费信息检索" },
  ],
};